// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
    background: rgb(255, 255, 255);
    /* padding: 20px; */
    border-radius: 8px;
    border: none;
    text-align: start;
    /* Set a max-width to ensure the modal doesn't stretch too wide */
    margin: 0 5px;
    /* Center the modal horizontally */
}

.modal-content h1 {
    font-size: 30px;
    font-weight: 500;
}

.highlight {
    color: rgb(255, 255, 255);
    padding: 3px;
    background: url(//s2.svgbox.net/pen-brushes.svg?ic=brush-1&color=c52026);
    margin: -2px -6px;
    padding: 1px 15px;
}

.input-group{
    background-color: #f7f7f7;
    border-radius: 15px;
    margin: 0;
    padding: 0;
    /* max-width: fit-content; */
}
/* Style for the email input box */
.email-input {
    background: transparent;
    border: none;
    /* border-radius: 4px; */
    font-size: 16px;
    padding: 10px;
    flex: 1 1;
    /* Allow the input to take available space */
}

/* Style for the submit button */
.modal-content .submit-button {
    border: none;
    background: transparent;
    padding: 0;
    padding-right: 10PX;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    cursor: pointer;
    height: 100%;
    width: fit-content;
}

.submit-button svg {
    vertical-align: middle;
    /* Ensure the icon size is consistent */
    /* Ensure the icon size is consistent */
}

.error-message {
    color: red;
    font-size: 14px;
    margin-top: 10px;
}

.content {
    margin-top: 20px;
}

@media (max-width: 540px) {
    .modal-content {
        min-width: 75vw;
    }
    .email-input{
        padding:  15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/BA/Modal.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iEAAiE;IACjE,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,wEAAwE;IACxE,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,4BAA4B;AAChC;AACA,kCAAkC;AAClC;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,SAAO;IACP,4CAA4C;AAChD;;AAEA,gCAAgC;AAChC;IACI,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;IACvC,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".modal-content {\n    background: rgb(255, 255, 255);\n    /* padding: 20px; */\n    border-radius: 8px;\n    border: none;\n    text-align: start;\n    /* Set a max-width to ensure the modal doesn't stretch too wide */\n    margin: 0 5px;\n    /* Center the modal horizontally */\n}\n\n.modal-content h1 {\n    font-size: 30px;\n    font-weight: 500;\n}\n\n.highlight {\n    color: rgb(255, 255, 255);\n    padding: 3px;\n    background: url(//s2.svgbox.net/pen-brushes.svg?ic=brush-1&color=c52026);\n    margin: -2px -6px;\n    padding: 1px 15px;\n}\n\n.input-group{\n    background-color: #f7f7f7;\n    border-radius: 15px;\n    margin: 0;\n    padding: 0;\n    /* max-width: fit-content; */\n}\n/* Style for the email input box */\n.email-input {\n    background: transparent;\n    border: none;\n    /* border-radius: 4px; */\n    font-size: 16px;\n    padding: 10px;\n    flex: 1;\n    /* Allow the input to take available space */\n}\n\n/* Style for the submit button */\n.modal-content .submit-button {\n    border: none;\n    background: transparent;\n    padding: 0;\n    padding-right: 10PX;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #000;\n    cursor: pointer;\n    height: 100%;\n    width: fit-content;\n}\n\n.submit-button svg {\n    vertical-align: middle;\n    /* Ensure the icon size is consistent */\n    /* Ensure the icon size is consistent */\n}\n\n.error-message {\n    color: red;\n    font-size: 14px;\n    margin-top: 10px;\n}\n\n.content {\n    margin-top: 20px;\n}\n\n@media (max-width: 540px) {\n    .modal-content {\n        min-width: 75vw;\n    }\n    .email-input{\n        padding:  15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
